import { Component, Input } from '@angular/core';
import { statusStateEnum } from '../types/types';
import { CommonModule } from '@angular/common';
import { IconModule } from '@rogers/cdk/icon';

@Component({
  standalone: true,
  imports: [CommonModule, IconModule],
  selector: 'ucx-status-indicator',
  templateUrl: './status-indicator.component.html',
  styleUrls: ['./status-indicator.component.scss'],
})
export class StatusIndicatorComponent {
  @Input() burialStage: any[] = [];
  @Input() burialClosedText = 'Burial Season Closed';
  @Input() set itemIndex(value: number) {
    this._itemIndex = value;
  }
  @Input() statusValue = '';
  @Input() statusState = '';
  @Input() set currentStatusIndex(value: number) {
    this._currentStatusIndex = value;
  }
  @Input() onEmitStatus;
  @Input() onEmitStage;
  @Input() burialSeasonClosed = false;
  statusStates = statusStateEnum;
  isBurialOnHold = false;

  @Input()
  set isLast(value: boolean) {
    this._isLast = value;
  }

  _isLast: boolean | undefined;
  _itemIndex = 0;
  _currentStatusIndex = 0;
  showIcon = true;

  setStatus() {
    this.showIcon = false;
    this.onEmitStatus(this.statusValue);
    if (this._itemIndex < this._currentStatusIndex) {
      this.onEmitStage(this.burialStage[0].STATUS_TYPE);
    } else if (this._itemIndex > this._currentStatusIndex) {
      this.onEmitStage(this.burialStage[2].STATUS_TYPE);
    } else {
      this.onEmitStage(this.burialStage[1].STATUS_TYPE);
    }
  }

  hideIcon() {
    this.showIcon = true;
  }

  setBurialClosedStatus() {
    if (this.burialSeasonClosed) {
      this.onEmitStatus(this.burialClosedText);
    }
  }

  getContent() {
    return this._itemIndex;
  }
}
